import clsx from 'clsx'
import {FC} from 'react'
import {useQueryRequest} from '../../core/QueryRequestProvider'

type Props = {
  className?: string
  title: string
  tableProps: any
}

const CustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const {state, updateState} = useQueryRequest()
  const id = tableProps.column.id

  const isSelectedForSorting = state.sort === id
  const order = isSelectedForSorting ? state.order : undefined

  const sortColumn = () => {
    if (!isSelectedForSorting) {
      updateState({sort: id, order: 'asc', ...{page: 1}})
      return
    }
    if (order === 'asc') {
      updateState({sort: id, order: 'desc', ...{page: 1}})
      return
    }
    updateState({sort: undefined, order: undefined, ...{page: 1}})
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`
      )}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {CustomHeader}
